// Learn time that could not be saved waits in localStorage and is replayed
// on the next classroom load (checkUnsavedLearnTime). It used to wait under
// one key for the whole browser, and logout never cleared it, so on a shared
// computer the next student to sign in replayed -- and was credited with --
// the previous student's time. Entries now wait under their student's key.
export const LEGACY_UNSAVED_LEARN_TIME_KEY = 'unsaved_learn_time';

/**
 * The student code in a token: the JWT's `username` claim. Read, never
 * verified -- this only decides which localStorage key to use; the server
 * still authorises every request with the token itself.
 * @param {string|null} token
 * @return {string|null}
 */
export function tokenStudentCode(token) {
  if (!token) return null;
  const jwt = String(token).trim().split(' ').pop();
  const part = jwt.split('.')[1];
  if (!part) return null;
  try {
    const binary = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    const json = decodeURIComponent(binary.split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
    const username = JSON.parse(json).username;
    return username ? String(username) : null;
  } catch (e) {
    return null;
  }
}

/** @return {string|null} the student signed in on this browser right now */
export function signedInStudentCode() {
  return tokenStudentCode(localStorage.getItem('token'));
}

/**
 * @param {string|null} studentCode
 * @return {string|null}
 */
export function unsavedLearnTimeKey(studentCode) {
  return studentCode ? `${LEGACY_UNSAVED_LEARN_TIME_KEY}:${studentCode}` : null;
}

/**
 * Whether the student signed in now owns an enrollment. 'different' means
 * another student signed in on this browser after the classroom loaded --
 * every request this page sends from then on carries the other student's
 * token. 'unknown' means one side has no code to compare.
 * @param {string|null|undefined} enrollStudentCode
 * @return {'same'|'different'|'unknown'}
 */
export function learnOwnerStatus(enrollStudentCode) {
  const signedIn = signedInStudentCode();
  if (!signedIn || !enrollStudentCode) return 'unknown';
  return signedIn === String(enrollStudentCode) ? 'same' : 'different';
}
